<template>
  <div class="content">
    <div class="top">
      <div class="elec_speed">
        <el-steps :active="0" finish-status="success" simple>
          <el-step :title=selectedSeries></el-step>
          <el-step :title=loadCondition></el-step>
          <el-step :title=reducerSize></el-step>
          <el-step :title=selectMotor></el-step>
          <el-step :title=complete></el-step>
        </el-steps>
      </div>
    </div>
    <div class="elec_select">
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple elec_select_left">
            <img :src=picUrl alt="" class="reducerPic">
            <!-- <div class="text">电机选择</div> -->
          </div>
        </el-col>
        <!-- 多级选择菜单 -->
        <el-col :span="12">
          <div class="grid-content bg-purple-light elec_select_right">
            <div class="select_box">
              <span style="padding-right:10px;">{{$t('message.reducerSeries')}}</span>
              <el-cascader
                :options="options"
                :show-all-levels="false"
                v-model="selectedOptions"
                :props="optionProps"
                @click.native="_getreducerseriesnamelist()"
                @change="handleChange">
              </el-cascader>
              <div class="toNextPage" @click="toNextPage">{{$t('message.Next')}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 减速机系列详情表 -->
    <div class="elec_detail">
      <el-row>
        <el-col :span="24">
          <h2 >{{$t('message.reducerList')}}</h2>
        </el-col>
        <el-col :span="24" style="padding-top:50px;">
          <el-tabs :tab-position="tabPosition">
            <el-tab-pane :label=ReducerList_20>
              <el-tabs :tab-position="tabPosition">
                <el-tab-pane label="KPE">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPL.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPE</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kpe')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：14-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：770-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：380-8000</el-col>
                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}:<=3</el-col>

                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：3-220</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-70</el-col>

                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>

                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KPL">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPL.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPL</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kpl')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：14-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：770-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：380-8000</el-col>
                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}:<=3</el-col>

                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：3-220</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-70</el-col>

                    </el-col>
                    <el-col :span="24" >
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>

                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KPLF">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPLF.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPLF</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kplf')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：14-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：770-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：380-8000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=3</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：3-220</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-70</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KPLS">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPLS.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPLS</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kpls')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：14-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：770-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：380-8000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=3</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：3-220</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-70</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KPLN">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPLN.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPLN</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kpln')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：14-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：770-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：380-8000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=3</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：3-220</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-70</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KPLFN">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPLFN.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPLFN</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kplfn')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：14-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：770-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：380-8000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=3</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：3-220</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-70</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KPX">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPX.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPX</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kpx')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：14-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：770-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：380-8000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=3</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：3-220</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-70</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KVX">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KVX.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KVX</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kvx')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：42-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：1500-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：760-8000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：89-95</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.064-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=3</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：3-220</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：23-75</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：3000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1500-3000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KPH">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPH.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPH</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kph')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：42-2050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_18')}}</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：2500-18000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：2000-15000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.064-23.67</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=3</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}：7-140</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：58-67</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-6000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-3000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KPG">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KPG.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KPG</h3>
                      <el-button size="mini" class="downloadButton" @click="download_k('kpg')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-2</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-100</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：42-1250</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：138-3750</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：1500-12000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：4400-17000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-95</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.064-28.98</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=3</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：1.6-40</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：58-67</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-6000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2500-4000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:7-140</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane :label=ReducerList_21>
              <el-tabs :tab-position="tabPosition">
                <el-tab-pane label="SPL">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/SPL.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">SPL</h3>
                      <el-button size="mini" class="downloadButton" @click="download_s('spl')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：12-1850</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_17')}}</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：385-14000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：250-7800</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：0.4-75</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-72</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：3000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1500-4000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:0.7-220</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="SPLF">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/SPLF.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">SPLF</h3>
                      <el-button size="mini" class="downloadButton" @click="download_s('splf')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：12-1850</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_17')}}</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：385-14000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：250-7800</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：0.4-75</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：56-72</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：3000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1500-4000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:0.7-220</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="SPLN">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/SPLN.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">SPLN</h3>
                      <el-button size="mini" class="downloadButton" @click="download_s('spln')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：32-1050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_17')}}</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：550-12000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：375-6800</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.064-28.98</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：1-48</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：58-70</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-6000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:3-120</el-col>

                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="SPLS">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/SPLS.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">SPLS</h3>
                      <el-button size="mini" class="downloadButton" @click="download_s('spls')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：32-1050</el-col>
                       <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_17')}}</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：550-12000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：375-6800</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.064-28.98</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：1-48</el-col>

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：58-70</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-6000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:3-120</el-col>

                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="SPX">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/SPX.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">SPX</h3>
                      <el-button size="mini" class="downloadButton" @click="download_s('spx')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：12-1850</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_17')}}</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：385-14000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：250-7800</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.016-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：0.4-75</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：55-72</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：3000-8000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1500-4000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:0.7-200</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="SVX">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/SVX.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">SVX</h3>
                      <el-button size="mini" class="downloadButton" @click="download_s('svx')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：32-1850</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_17')}}</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：550-14000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：375-7800</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：92-96</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.064-69.61</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：2.2-90</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：58-72</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：3000-6000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1500-4000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:3-200</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="SPH">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/SPH.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">SPH</h3>
                      <el-button size="mini" class="downloadButton" @click="download_s('sph')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：32-1050</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_17')}}</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：2000-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：1600-13000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：93-97</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.064-28.98</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：1-48</el-col>

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：58-70</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：4000-6000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：2000-4000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:3-120</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane :label=ReducerList_23>
              <el-tabs :tab-position="tabPosition">
                <el-tab-pane label="KT-FL">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KT-FL.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KT-FL</h3>
                      <el-button size="mini" class="downloadButton" @click="download_kt('kt-fl')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：1-50</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：32-2150</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：64-4300</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：1100-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：550-8500</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：92-96</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.14-369.34</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：4.4-115.2</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：72-83</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：1800-6000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1200-3000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="KT-FH">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/KT-FH.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">KT-FH</h3>
                      <el-button size="mini" class="downloadButton" @click="download_kt('kt-fh')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：1-50</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：32-2010</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：64-4300</el-col>
                    </el-col>
                    <el-col :span="24">

                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：1100-16000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：550-8500</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：92-96</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>

                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:0.14-369.34</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=8</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：4.4-115.2</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：72-83</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：1800-6000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1200-3000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane :label=ReducerList_22>
              <el-tabs :tab-position="tabPosition">
                <el-tab-pane label="PX">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/PX.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">PX</h3>
                      <el-button size="mini" class="downloadButton" @click="download_px('px')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：1-3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：3-512</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：26500</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：90-96</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:10000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:14.5-239.5</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：<=22</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：39-360</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：70-75</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：2000-3000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1500-2000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}:66.7-536.4</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：745-20760</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：{{$t('message.ReducerList_17')}}</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane label="PWZD">
                  <el-row :gutter="0" class="detail_img_box">
                    <el-col :span="5">
                      <img class="detail_img" src="../../../static/seriesPic/PWZD.png" alt=""/>
                    </el-col>
                    <el-col :span="5" class="grid-content-box" style="padding-top:30px;">
                      <h3 class="imgTitle">PWZD</h3>
                      <el-button size="mini" class="downloadButton" @click="download_pwzd('pwzd')">{{$t('message.ReducerList_19')}}</el-button>
                    </el-col>
                    <el-col :span="24" style="padding-top:10px;">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_1')}}：3</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_2')}}：80-320</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_3')}}：6400-85000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_4')}}：12800-170000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_5')}}：31800-174000</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_6')}}：7950-43500</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_7')}}：90</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_8')}}:20000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_9')}}:40-230</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_10')}}：无</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_15')}}：90-730</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_12')}}：75</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_14')}}：1500</el-col>
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_13')}}：2000</el-col>
                    </el-col>
                    <el-col :span="24">
                      <el-col :span="12" class="detail_text">{{$t('message.ReducerList_11')}}: 200-1000</el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import {
    getreducerseriesnamelist
  }from '@/store/electric_load'
  import {
    downloadDetailFile_k,
    downloadDetailFile_s,
    downloadDetailFile_px,
    downloadDetailFile_pwzd,
    downloadDetailFile_kt
  } from '@/store/electric_download'
  import {
    getPicUrl
  } from '@/store/electric_motor'
  export default {
    name: 'SelectedSeries',
    data() {
      return {
        options: [],
        selectedOptions: [],
        tabPosition: 'left',
        optionProps: {
          value: 'reducer_series_name',
          label: 'label',
        },
        reducerName:'',
        selectedSeries: this.$t('message.selectedSeries'),
        loadCondition: this.$t('message.loadCondition'),
        reducerSize: this.$t('message.reducerSize'),
        selectMotor: this.$t('message.selectMotor'),
        complete: this.$t('message.complete'),
        ReducerList_20 : this.$t('message.ReducerList_20'),
        ReducerList_21 : this.$t('message.ReducerList_21'),
        ReducerList_22 : this.$t('message.ReducerList_22'),
        ReducerList_23 : this.$t('message.ReducerList_23'),
        param_file:{},
        picUrl:''
      };
    },
    mounted(){
      this.picUrl = '../../../static/seriesPic/KPL.png';
    },
    methods: {
      toNextPage:function(){
        if(this.reducerName !== ''){
          this.$emit("listenPageChange","to_LoadPage");
          this.$emit("listenParam",this.reducerName);
        }else{
          this.$message({
            message: '请选择减速机系列!',
            type: 'warning'
          });
        }
      },
      handleChange:function(value){
        this.reducerName = value[0];
        getPicUrl(value[0]).then((response)=>{
          if (response.success === true) {
            this.picUrl = response.data[0].outlook_picture
          }
        })
      },
      // 获取减速机系列列表
      _getreducerseriesnamelist:function(){
        getreducerseriesnamelist().then((response) => {
          if (response.success === true) {
            this.options = [];
            this.options = response.data;
          }
        })
      },
      // 下载文档
      download_k(value) {
        this.param_file.name = value.toUpperCase();
        downloadDetailFile_k(this.param_file);
      },
      download_s(value) {
        this.param_file.name = value.toUpperCase();
        downloadDetailFile_s(this.param_file);
      },
      download_px(value) {
        this.param_file.name = value.toUpperCase();
        downloadDetailFile_px(this.param_file);
      },
      download_pwzd(value) {
        this.param_file.name = value.toUpperCase();
        downloadDetailFile_pwzd(this.param_file);
      },
      download_kt(value) {
        this.param_file.name = value.toUpperCase();
        downloadDetailFile_kt(this.param_file);
      }
    }
  };
</script>
<style scoped>
  .detail_text {
    margin-top:5px;
  }
  .content {
    width:100%;
    height: 1000px;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 15px rgb(224, 224, 224);
  }
  .top {
    height:100px;
    border-bottom:1px solid #EBEBEB;
  }
  .elec_speed {
    width:80%;
    margin:0 auto;
    padding-top:25px;
  }
  .el-steps {
    border-radius: 10px;
    background-color: #F5F7FA;
    background:url('../../../static/step.png') no-repeat #F5F7FA;
    background-size:24% 100%;
    background-position-x:0%;
  }
  .elec_select_left img {
    width: 35%;
    height: 35%;
    display: block;
    margin: 0 auto;
    padding-top: 100px;
  }
  .elec_select_left .text{
    text-align: center;
    font-weight: bold;
  }
  .el-cascader-menus el-popper{
    z-index: 2010;
    position: absolute;
    top: 284px;
    left: 952px;
  }
  .select_box {
    padding-left:10px;
    padding-top:130px;
  }
  .toNextPage {
    width:97px;
    height:42px;
    border-radius: 5px;
    background: #142479;
    text-align: center;
    line-height: 42px;
    color:white;
    margin-top:40px;
    cursor: pointer;
  }
  .elec_detail {
    width:80%;
    margin:0 auto;
    margin-top:70px;
  }
  .detail_img {
    width:130px;
    height:120px;
  }
  .detail_img_box {
    width:90%;
    height:450px;
    margin:0 auto;
    padding-top:10px;
    font-size: 14px;
    overflow: auto;
  }
  .infoTitle {
    width:240px;
    display: inline-block;
    padding:0px 10px 10px 10px;
  }
  .infoTitle_2 {
    width:240px;
    display: inline-block;
    padding:0px 10px 10px 10px;
  }
  .downloadButton {
    margin-top:10px;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .grid-content-box {
      padding-left:20px;
    }
    .imgTitle {
      padding-left: 20px;
    }
    .downloadButton {
      margin-left:18px;
      margin-top:10px;
    }
    .detail_img_box {
      width:90%;
      height:550px;
      margin:0 auto;
      padding-top:10px;
      font-size: 14px;
      overflow: auto;
    }
    .infoTitle {
      width:180px;
      display: inline-block;
      padding:0px 10px 10px 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/LoadSelection/SelectedSeries.vue